import React from 'react';

const PlanetIcon = () => {
  return (
    <svg
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      // xmlns:xlink='http://www.w3.org/1999/xlink'
      x='0px'
      y='0px'
      viewBox='0 0 512.006 512.006'
      // style={{enable-background:'new 0 0 512.006 512.006'}}
      xmlSpace='preserve'
    >
      <circle style={{ fill: 'none' }} cx='256.003' cy='256.003' r='256.003' />
      <path
        style={{ fill: '#4F772D' }}
        d='M256.312,148.19c-59.541-63.671,7.684-162.05,111.725-87.595c0,0-28.926-3.657-40.721,10.76
	C311.1,91.168,332.892,139.543,256.312,148.19z'
      />
      <path
        style={{ fill: '#31572C' }}
        d='M344.191,46.25c7.684,3.736,15.641,8.483,23.839,14.345c0,0-28.926-3.657-40.727,10.76
	c-4.451,5.45-5.958,13.6-7.393,22.743l0,0c-1.623-8.816,0.242-42.641,24.275-47.854L344.191,46.25z'
      />
      <path
        style={{ fill: 'black' }}
        d='M320.933,49.259c-65.621-2.822-70.071,64.149-70.495,175.214h11.917
	c0.333-59.408-10.585-179.731,58.572-175.214H320.933z'
      />
      <path
        style={{ fill: '#4F772D' }}
        d='M238.485,168.753c19.752-53.97-63.005-91.18-96-21.678c0,0,16.616-9.664,27.491-3.948
	C184.921,150.981,189.777,183.213,238.485,168.753z'
      />
      <g>
        <path
          style={{ fill: 'black' }}
          d='M168.705,124.768c34-18.359,70.774,33.098,82.908,58.548l0.799,20.079
		C236.196,169.238,202.457,111.156,168.705,124.768z'
        />
        <path
          style={{ fill: '#4F772D' }}
          d='M256.003,215.118c34.951,0,66.595,14.169,89.496,37.07c22.907,22.901,37.07,54.546,37.07,89.496
		s-14.163,66.595-37.07,89.496c-22.901,22.901-54.546,37.07-89.496,37.07s-66.595-14.169-89.496-37.07
		c-22.901-22.907-37.07-54.546-37.07-89.496c0-34.957,14.169-66.595,37.07-89.496C189.408,229.281,221.052,215.118,256.003,215.118z
		 M346.662,410.878c-8.114-3.488-18.275-6.297-29.707-8.435c-1.072,2.289-2.204,4.547-3.409,6.782
		c-9.264,17.239-22.35,32.735-39.25,45.039c24.166-3.893,45.79-15.38,62.345-31.935C340.225,418.743,343.58,414.917,346.662,410.878
		z M304.051,400.384c-13.116-1.762-27.364-2.755-41.781-2.973v49.998c17.596-11.626,31.021-26.909,40.267-44.106
		c0.521-0.969,1.023-1.938,1.52-2.919H304.051z M249.736,397.417c-14.405,0.23-28.641,1.235-41.763,3.003
		c0.484,0.963,0.987,1.926,1.496,2.882c9.246,17.197,22.671,32.48,40.267,44.106V397.417z M195.069,402.485
		c-11.408,2.131-21.569,4.935-29.719,8.405c3.082,4.033,6.431,7.854,10.009,11.438c16.555,16.555,38.178,28.042,62.345,31.935
		c-16.9-12.304-29.986-27.8-39.25-45.039C197.261,407.008,196.135,404.762,195.069,402.485z M158.217,400.402
		c8.756-3.984,19.704-7.2,31.99-9.652c-4.977-13.751-7.793-28.211-8.447-42.75h-39.625
		C143.176,367.098,148.91,384.943,158.217,400.402z M202.735,388.576c14.732-2.198,30.809-3.427,47.001-3.688V348h-55.472
		c0.678,13.83,3.506,27.576,8.477,40.576H202.735z M262.264,384.883c16.21,0.242,32.293,1.459,47.019,3.645
		c4.959-12.988,7.781-26.716,8.459-40.528H262.27v36.882H262.264z M321.811,390.696c12.316,2.452,23.264,5.68,31.984,9.676
		c9.295-15.453,15.023-33.286,16.065-52.372h-39.625c-0.648,14.52-3.458,28.962-8.429,42.695H321.811z M351.113,278.753
		c-8.356,4.033-18.874,7.297-30.718,9.785c5.922,14.981,9.21,30.9,9.87,46.928h39.607c-1.126-20.897-7.872-40.292-18.753-56.713
		H351.113z M307.842,290.815c-14.266,2.216-29.858,3.445-45.572,3.7v40.952h55.502c-0.684-15.296-3.99-30.47-9.925-44.651H307.842z
		 M249.736,294.508c-15.701-0.272-31.281-1.514-45.56-3.736c-5.946,14.193-9.258,29.38-9.943,44.694h55.502V294.508z
		 M191.624,288.495c-11.826-2.489-22.344-5.734-30.73-9.749c-10.887,16.422-17.639,35.823-18.759,56.719h39.607
		c0.654-16.046,3.954-31.978,9.888-46.97H191.624z M168.541,268.501c7.775,3.433,17.451,6.219,28.326,8.344
		c0.593-1.169,1.205-2.331,1.829-3.488c9.222-16.943,22.162-32.147,38.814-44.215c-24.094,3.924-45.644,15.392-62.151,31.905
		c-2.38,2.38-4.656,4.868-6.818,7.448V268.501z M209.844,279.001c12.54,1.75,26.134,2.737,39.886,2.973v-46.068
		c-17.366,11.348-30.664,26.268-39.886,43.089V279.001z M262.264,281.98c13.776-0.224,27.376-1.199,39.91-2.937
		c-9.222-16.84-22.525-31.778-39.91-43.137V281.98z M315.157,276.894c10.899-2.125,20.582-4.917,28.32-8.368
		c-2.168-2.592-4.451-5.086-6.842-7.478c-16.507-16.513-38.063-27.981-62.151-31.905c16.652,12.068,29.592,27.273,38.814,44.215
		C313.933,274.532,314.551,275.707,315.157,276.894z'
        />
      </g>
      <path
        style={{ fill: '#31572C' }}
        d='M150.315,133.706c-2.531,3.839-5.643,8.411-7.829,13.37c15.677-8.362,26.371-8.15,35.829,3.294
	C173.343,141.989,161.947,129.824,150.315,133.706z'
      />
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};

export default PlanetIcon;
